/*==============================================================================
TRESTLE™ W007
YOUR TRESTLE INSIGHT

Brand        : Diafemme®
Module       : W007
File         : TRESTLE_W007_Insight.js

Version      : 1.0
Status       : PRODUCTION

Responsibilities
----------------
• Connect W007 UI to TrestleW007Engine
• Manage 7 PM Insight availability
• Render today's Insight
• Render archived Insights
• Open / close Insight reader
• Download / Print Insight
• Share Insight
• Handle sparse-data states
==============================================================================*/

"use strict";


const TrestleW007 = (() => {


/*==============================================================================
RUNTIME
==============================================================================*/

let root = null;

let currentInsight = null;

let currentInsightDate = null;


/*==============================================================================
DOM REFERENCES
==============================================================================*/

const Elements = {

    status: null,
    statusText: null,

    openButton: null,
    historyButton: null,

    reader: null,
    closeButton: null,

    readerDate: null,
    greeting: null,
    sparseIntro: null,

    glanceSection: null,
    glanceIntro: null,
    glanceGrid: null,
    observations: null,

    scienceSection: null,
    scienceContent: null,

    promiseSection: null,
    promiseName: null,
    promiseText: null,

    noticeSection: null,
    noticeText: null,

    focusSection: null,
    focusText: null,

    doctorSection: null,
    doctorIntro: null,
    doctorQuestions: null,

    sourcesSection: null,
    sources: null,

    closing: null,
    disclaimer: null,

    downloadButton: null,
    shareButton: null,

    historyPanel: null,
    historyClose: null,
    historyList: null

};


/*==============================================================================
SAFE STRING
==============================================================================*/

function safeString(value) {

    if (
        value === null ||
        value === undefined
    ) {

        return "";

    }

    return String(value).trim();

}


/*==============================================================================
ESCAPE HTML
==============================================================================*/

function escapeHtml(value) {

    return safeString(value)

        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");

}


/*==============================================================================
CACHE ELEMENTS
==============================================================================*/

function cacheElements() {

    root =
        document.getElementById(
            "trW007Insight"
        );


    if (!root) {

        return false;

    }


    Elements.status =
        document.getElementById(
            "trW007Status"
        );

    Elements.statusText =
        document.getElementById(
            "trW007StatusText"
        );


    Elements.openButton =
        document.getElementById(
            "trW007Open"
        );

    Elements.historyButton =
        document.getElementById(
            "trW007History"
        );


    Elements.reader =
        document.getElementById(
            "trW007Reader"
        );

    Elements.closeButton =
        document.getElementById(
            "trW007Close"
        );


    Elements.readerDate =
        document.getElementById(
            "trW007ReaderDate"
        );

    Elements.greeting =
        document.getElementById(
            "trW007Greeting"
        );

    Elements.sparseIntro =
        document.getElementById(
            "trW007SparseIntro"
        );


    Elements.glanceSection =
        document.getElementById(
            "trW007GlanceSection"
        );

    Elements.glanceIntro =
        document.getElementById(
            "trW007GlanceIntro"
        );

    Elements.glanceGrid =
        document.getElementById(
            "trW007GlanceGrid"
        );

    Elements.observations =
        document.getElementById(
            "trW007Observations"
        );


    Elements.scienceSection =
        document.getElementById(
            "trW007ScienceSection"
        );

    Elements.scienceContent =
        document.getElementById(
            "trW007ScienceContent"
        );


    Elements.promiseSection =
        document.getElementById(
            "trW007PromiseSection"
        );

    Elements.promiseName =
        document.getElementById(
            "trW007PromiseName"
        );

    Elements.promiseText =
        document.getElementById(
            "trW007PromiseText"
        );


    Elements.noticeSection =
        document.getElementById(
            "trW007NoticeSection"
        );

    Elements.noticeText =
        document.getElementById(
            "trW007NoticeText"
        );


    Elements.focusSection =
        document.getElementById(
            "trW007FocusSection"
        );

    Elements.focusText =
        document.getElementById(
            "trW007FocusText"
        );


    Elements.doctorSection =
        document.getElementById(
            "trW007DoctorSection"
        );

    Elements.doctorIntro =
        document.getElementById(
            "trW007DoctorIntro"
        );

    Elements.doctorQuestions =
        document.getElementById(
            "trW007DoctorQuestions"
        );


    Elements.sourcesSection =
        document.getElementById(
            "trW007SourcesSection"
        );

    Elements.sources =
        document.getElementById(
            "trW007Sources"
        );


    Elements.closing =
        document.getElementById(
            "trW007Closing"
        );

    Elements.disclaimer =
        document.getElementById(
            "trW007Disclaimer"
        );


    Elements.downloadButton =
        document.getElementById(
            "trW007Download"
        );

    Elements.shareButton =
        document.getElementById(
            "trW007Share"
        );


    Elements.historyPanel =
        document.getElementById(
            "trW007HistoryPanel"
        );

    Elements.historyClose =
        document.getElementById(
            "trW007HistoryClose"
        );

    Elements.historyList =
        document.getElementById(
            "trW007HistoryList"
        );


    return true;

}

/*==============================================================================
W007 MEMBERSHIP ACCESS
==============================================================================*/

function canAccessInsight() {

    return Boolean(
        window.TrestleAccess &&
        window.TrestleAccess.canAccessInsight === true
    );

}


/*==============================================================================
APPLY W007 ACCESS STATE
==============================================================================*/

function applyAccessState() {

    if (canAccessInsight()) {

        return true;

    }


    currentInsight = null;
    currentInsightDate = null;


    setStatus(
        "light",
        "TRESTLE Insight is available with Corporate or Individual Membership."
    );


    setOpenButton(
        false,
        "Membership Required"
    );


    if (Elements.historyButton) {

        Elements.historyButton.disabled = true;

        Elements.historyButton.textContent =
            "Membership Required";

    }


    return false;

}
/*==============================================================================
ENGINE AVAILABLE
==============================================================================*/

function engineAvailable() {

    return Boolean(

        window.TrestleW007Engine &&
        typeof window.TrestleW007Engine
            .getTodayInsight ===
            "function"

    );

}


/*==============================================================================
FORMAT DATE
==============================================================================*/

function formatDate(dateString) {

    const value =
        safeString(
            dateString
        );


    if (!value) {

        return "";

    }


    try {

        const parts =
            value.split("-");


        if (parts.length !== 3) {

            return value;

        }


        const date =
            new Date(

                Number(parts[0]),

                Number(parts[1]) - 1,

                Number(parts[2])

            );


        return new Intl.DateTimeFormat(

            "en-IN",

            {

                weekday: "long",
                day: "numeric",
                month: "long",
                year: "numeric"

            }

        ).format(date);

    }

    catch (error) {

        return value;

    }

}


/*==============================================================================
SET STATUS
==============================================================================*/

function setStatus(
    type,
    message
) {

    if (!Elements.status) {

        return;

    }


    Elements.status.classList.remove(

        "is-ready",
        "is-waiting",
        "is-light",
        "is-error"

    );


    if (type) {

        Elements.status.classList.add(
            `is-${type}`
        );

    }


    if (Elements.statusText) {

        Elements.statusText.textContent =
            safeString(message);

    }

}


/*==============================================================================
ENABLE / DISABLE TODAY BUTTON
==============================================================================*/

function setOpenButton(
    enabled,
    label
) {

    if (!Elements.openButton) {

        return;

    }


    Elements.openButton.disabled =
        !enabled;


    if (label) {

        Elements.openButton.textContent =
            label;

    }

}


/*==============================================================================
GET FIRST NAME
==============================================================================*/

function getFirstName(insight) {

    if (
        insight &&
        insight.identity
    ) {

        const firstName =
            safeString(
                insight.identity.firstName
            );


        if (firstName) {

            return firstName;

        }

    }


    if (
        window.TrestleCustomer &&
        window.TrestleCustomer.firstName
    ) {

        return safeString(
            window.TrestleCustomer.firstName
        );

    }


    return "";

}


/*==============================================================================
RESET REPORT
==============================================================================*/

function resetReport() {

    currentInsight = null;
    currentInsightDate = null;


    if (Elements.readerDate) {

        Elements.readerDate.textContent = "";

    }


    if (Elements.greeting) {

        Elements.greeting.textContent =
            "Your day, reflected back to you.";

    }


    if (Elements.sparseIntro) {

        Elements.sparseIntro.textContent = "";
        Elements.sparseIntro.hidden = true;

    }


    if (Elements.glanceIntro) {

        Elements.glanceIntro.textContent = "";

    }


    if (Elements.glanceGrid) {

        Elements.glanceGrid.innerHTML = "";

    }


    if (Elements.observations) {

        Elements.observations.innerHTML = "";
        Elements.observations.hidden = true;

    }


    if (Elements.scienceSection) {

        Elements.scienceSection.hidden = true;

    }


    if (Elements.scienceContent) {

        Elements.scienceContent.innerHTML = "";

    }


    if (Elements.promiseSection) {

        Elements.promiseSection.hidden = true;

    }


    if (Elements.promiseName) {

        Elements.promiseName.textContent = "";

    }


    if (Elements.promiseText) {

        Elements.promiseText.textContent = "";

    }


    if (Elements.noticeSection) {

        Elements.noticeSection.hidden = true;

    }


    if (Elements.noticeText) {

        Elements.noticeText.textContent = "";

    }


    if (Elements.focusSection) {

        Elements.focusSection.hidden = true;

    }


    if (Elements.focusText) {

        Elements.focusText.textContent = "";

    }


    if (Elements.doctorSection) {

        Elements.doctorSection.hidden = true;

    }


    if (Elements.doctorIntro) {

        Elements.doctorIntro.textContent = "";

    }


    if (Elements.doctorQuestions) {

        Elements.doctorQuestions.innerHTML = "";

    }


    if (Elements.sourcesSection) {

        Elements.sourcesSection.hidden = true;

    }


    if (Elements.sources) {

        Elements.sources.innerHTML = "";

    }


    if (Elements.closing) {

        Elements.closing.textContent = "";

    }


    if (Elements.disclaimer) {

        Elements.disclaimer.textContent = "";

    }


    if (Elements.downloadButton) {

        Elements.downloadButton.disabled = true;

    }


    if (Elements.shareButton) {

        Elements.shareButton.disabled = true;

    }

}


/*==============================================================================
NORMALIZE GLANCE ITEM
==============================================================================*/

function normalizeGlanceItem(
    item,
    index
) {

    if (
        item === null ||
        item === undefined
    ) {

        return null;

    }


    if (
        typeof item === "string" ||
        typeof item === "number"
    ) {

        return {

            label:
                `Check-in ${index + 1}`,

            value:
                safeString(item),

            secondary:
                ""

        };

    }


    if (typeof item !== "object") {

        return null;

    }


    return {

        label:
            safeString(

                item.label ||
                item.title ||
                item.name ||
                item.domain ||
                item.type

            ),

        value:
            safeString(

                item.value ||
                item.displayValue ||
                item.summary ||
                item.text ||
                item.status

            ),

        secondary:
            safeString(

                item.secondary ||
                item.detail ||
                item.time ||
                item.note ||
                item.unit

            )

    };

}


/*==============================================================================
RENDER DAY AT A GLANCE
==============================================================================*/

function renderDayAtGlance(
    dayAtGlance
) {

    const data =
        dayAtGlance &&
        typeof dayAtGlance === "object"

            ? dayAtGlance

            : {};


    if (Elements.glanceIntro) {

        Elements.glanceIntro.textContent =
            safeString(
                data.intro
            );

    }


    let items = [];


    if (Array.isArray(data.items)) {

        items =
            data.items;

    }


    if (Elements.glanceGrid) {

        const normalized =
            items

                .map(normalizeGlanceItem)

                .filter(

                    item =>
                        item &&
                        (
                            item.label ||
                            item.value
                        )

                );


        if (normalized.length) {

            Elements.glanceGrid.innerHTML =
                normalized

                    .map(

                        item => `

                            <div class="tr-w007-glance-item">

                                <span class="tr-w007-glance-label">
                                    ${escapeHtml(item.label)}
                                </span>

                                <span class="tr-w007-glance-value">
                                    ${escapeHtml(item.value)}
                                </span>

                                ${
                                    item.secondary

                                        ? `
                                            <span class="tr-w007-glance-secondary">
                                                ${escapeHtml(item.secondary)}
                                            </span>
                                          `

                                        : ""
                                }

                            </div>

                        `

                    )

                    .join("");

        }

        else {

            Elements.glanceGrid.innerHTML =
                `
                    <div class="tr-w007-glance-item">

                        <span class="tr-w007-glance-label">
                            Today's record
                        </span>

                        <span class="tr-w007-glance-value">
                            A light check-in day
                        </span>

                    </div>
                `;

        }

    }


    const observations =
        Array.isArray(
            data.factualObservations
        )

            ? data.factualObservations

            : [];


    if (
        Elements.observations &&
        observations.length
    ) {

        Elements.observations.innerHTML =
            observations

                .map(

                    observation => {

                        const text =
                            typeof observation ===
                            "object"

                                ? safeString(
                                    observation.text ||
                                    observation.summary
                                )

                                : safeString(
                                    observation
                                );


                        if (!text) {

                            return "";

                        }


                        return (
                            `<p>${escapeHtml(text)}</p>`
                        );

                    }

                )

                .join("");


        Elements.observations.hidden =
            !Elements.observations
                .innerHTML
                .trim();

    }

}


/*==============================================================================
RENDER SCIENCE
==============================================================================*/

function renderScience(items) {

    if (
        !Elements.scienceSection ||
        !Elements.scienceContent
    ) {

        return;

    }


    const science =
        Array.isArray(items)
            ? items
            : [];


    if (!science.length) {

        Elements.scienceSection.hidden =
            true;

        return;

    }


    Elements.scienceContent.innerHTML =
        science

            .map(

                item => {

                    if (!item) {

                        return "";

                    }


                    const text =
                        typeof item === "object"

                            ? safeString(
                                item.text ||
                                item.summary
                            )

                            : safeString(
                                item
                            );


                    if (!text) {

                        return "";

                    }


                    const authority =
                        typeof item === "object"

                            ? safeString(

                                item.authority ||
                                item.sourceLabel ||
                                item.source

                            )

                            : "";


                    return `

                        <div class="tr-w007-science-item">

                            ${
                                authority

                                    ? `
                                        <span class="tr-w007-science-authority">
                                            ${escapeHtml(authority)}
                                        </span>
                                      `

                                    : ""
                            }

                            <p>
                                ${escapeHtml(text)}
                            </p>

                        </div>

                    `;

                }

            )

            .join("");


    Elements.scienceSection.hidden =
        !Elements.scienceContent
            .innerHTML
            .trim();

}


/*==============================================================================
RENDER PROMISE
==============================================================================*/

function renderPromise(
    insight
) {

    if (!Elements.promiseSection) {

        return;

    }


    const promiseInsight =
        insight.promiseInsight;


    if (
        !promiseInsight ||
        !safeString(
            promiseInsight.text
        )
    ) {

        Elements.promiseSection.hidden =
            true;

        return;

    }


    const promise =
        insight.profile

            ? safeString(
                insight.profile.promise
            )

            : "";


    if (Elements.promiseName) {

        Elements.promiseName.textContent =
            promise

                ? `Your Promise: ${promise}`

                : "Your chosen Promise";

    }


    if (Elements.promiseText) {

        Elements.promiseText.textContent =
            safeString(
                promiseInsight.text
            );

    }


    Elements.promiseSection.hidden =
        false;

}


/*==============================================================================
RENDER SOMETHING TO NOTICE
==============================================================================*/

function renderNotice(
    contradiction
) {

    if (!Elements.noticeSection) {

        return;

    }


    const text =
        contradiction

            ? safeString(
                contradiction.text
            )

            : "";


    if (!text) {

        Elements.noticeSection.hidden =
            true;

        return;

    }


    if (Elements.noticeText) {

        Elements.noticeText.textContent =
            text;

    }


    Elements.noticeSection.hidden =
        false;

}


/*==============================================================================
RENDER TOMORROW FOCUS
==============================================================================*/

function renderFocus(
    focus
) {

    if (!Elements.focusSection) {

        return;

    }


    const text =
        focus

            ? safeString(
                focus.text
            )

            : "";


    if (!text) {

        Elements.focusSection.hidden =
            true;

        return;

    }


    if (Elements.focusText) {

        Elements.focusText.textContent =
            text;

    }


    Elements.focusSection.hidden =
        false;

}


/*==============================================================================
RENDER DOCTOR QUESTIONS
==============================================================================*/

function renderDoctorQuestions(
    insight
) {

    if (
        !Elements.doctorSection ||
        !Elements.doctorQuestions
    ) {

        return;

    }


    const questions =
        Array.isArray(
            insight.doctorQuestions
        )

            ? insight.doctorQuestions

            : [];


    if (!questions.length) {

        Elements.doctorSection.hidden =
            true;

        return;

    }


    if (Elements.doctorIntro) {

        Elements.doctorIntro.textContent =
            safeString(
                insight.doctorSectionIntro
            );

    }


    Elements.doctorQuestions.innerHTML =
        questions

            .map(

                item => {

                    const question =
                        typeof item === "object"

                            ? safeString(
                                item.question ||
                                item.text
                            )

                            : safeString(
                                item
                            );


                    if (!question) {

                        return "";

                    }


                    return `

                        <div class="tr-w007-doctor-question">
                            ${escapeHtml(question)}
                        </div>

                    `;

                }

            )

            .join("");


    Elements.doctorSection.hidden =
        !Elements.doctorQuestions
            .innerHTML
            .trim();

}


/*==============================================================================
SOURCE LIBRARY
==============================================================================*/

function getSourceLibrary() {

    const possibleSources = [

        window.TRESTLE_W007_INSIGHT_DATA,

        window.TrestleW007InsightData,

        window.TrestleW007Data

    ];


    for (
        let i = 0;
        i < possibleSources.length;
        i++
    ) {

        const data =
            possibleSources[i];


        if (
            data &&
            typeof data === "object"
        ) {

            return (

                data.sourceLibrary ||
                data.sources ||
                {}

            );

        }

    }


    return {};

}


/*==============================================================================
RESOLVE SOURCE
==============================================================================*/

function resolveSource(
    sourceId
) {

    const library =
        getSourceLibrary();


    if (!library) {

        return null;

    }


    if (Array.isArray(library)) {

        return (

            library.find(

                item =>
                    item &&
                    (
                        item.id === sourceId ||
                        item.sourceId === sourceId
                    )

            ) || null

        );

    }


    return (
        library[sourceId] ||
        null
    );

}


/*==============================================================================
RENDER SOURCES
==============================================================================*/

function renderSources(
    sourceIds
) {

    if (
        !Elements.sourcesSection ||
        !Elements.sources
    ) {

        return;

    }


    const ids =
        Array.isArray(sourceIds)
            ? sourceIds
            : [];


    if (!ids.length) {

        Elements.sourcesSection.hidden =
            true;

        return;

    }


    const rendered =
        ids

            .map(

                id => {

                    const source =
                        resolveSource(id);


                    if (!source) {

                        return "";

                    }


                    const authority =
                        safeString(

                            source.authority ||
                            source.organization ||
                            source.name ||
                            source.title

                        );


                    const title =
                        safeString(

                            source.title ||
                            source.guidance ||
                            source.description

                        );


                    const year =
                        safeString(
                            source.year
                        );


                    const text = [

                        authority,
                        title,
                        year

                    ]
                        .filter(Boolean)
                        .join(" — ");


                    if (!text) {

                        return "";

                    }


                    return (
                        `<p class="tr-w007-source">${escapeHtml(text)}</p>`
                    );

                }

            )

            .filter(Boolean);


    if (!rendered.length) {

        Elements.sourcesSection.hidden =
            true;

        return;

    }


    Elements.sources.innerHTML =
        rendered.join("");


    Elements.sourcesSection.hidden =
        false;

}


/*==============================================================================
RENDER INSIGHT
==============================================================================*/

function renderInsight(
    insight
) {

    if (
        !insight ||
        typeof insight !== "object"
    ) {

        return false;

    }


    resetReport();


    currentInsight =
        insight;

    currentInsightDate =
        safeString(
            insight.date
        );


    if (Elements.readerDate) {

        Elements.readerDate.textContent =
            formatDate(
                insight.date
            );

    }


    const firstName =
        getFirstName(
            insight
        );


    if (Elements.greeting) {

        Elements.greeting.textContent =
            firstName

                ? `${firstName}, here is your day reflected back to you.`

                : "Your day, reflected back to you.";

    }


    const sparseIntro =
        safeString(
            insight.sparseIntro
        );


    if (
        Elements.sparseIntro &&
        sparseIntro
    ) {

        Elements.sparseIntro.textContent =
            sparseIntro;

        Elements.sparseIntro.hidden =
            false;

    }


    renderDayAtGlance(
        insight.dayAtGlance
    );


    renderScience(
        insight.scienceAndYourDay
    );


    renderPromise(
        insight
    );


    renderNotice(
        insight.contradictionObservation
    );


    renderFocus(
        insight.tomorrowFocus
    );


    renderDoctorQuestions(
        insight
    );


    renderSources(
        insight.sourceIds
    );


    if (Elements.closing) {

        Elements.closing.textContent =
            safeString(
                insight.closing
            );

    }


    if (Elements.disclaimer) {

        Elements.disclaimer.textContent =
            safeString(
                insight.disclaimer
            );

    }


    if (Elements.downloadButton) {

        Elements.downloadButton.disabled =
            insight.allowPdf === false;

    }


    if (Elements.shareButton) {

        Elements.shareButton.disabled =
            insight.allowShare === false;

    }


    return true;

}


/*==============================================================================
OPEN READER
==============================================================================*/

function openReader(
    insight
) {

    if (
        !Elements.reader ||
        !insight
    ) {

        return;

    }


    if (!renderInsight(insight)) {

        return;

    }


    closeHistory();


    Elements.reader.classList.add(
        "is-open"
    );

    Elements.reader.setAttribute(
        "aria-hidden",
        "false"
    );


    document.body.classList.add(
        "tr-w007-modal-open"
    );


    if (Elements.closeButton) {

        window.setTimeout(

            () =>
                Elements.closeButton.focus(),

            30

        );

    }

}


/*==============================================================================
CLOSE READER
==============================================================================*/

function closeReader() {

    if (!Elements.reader) {

        return;

    }


    Elements.reader.classList.remove(
        "is-open"
    );

    Elements.reader.setAttribute(
        "aria-hidden",
        "true"
    );


    if (
        !Elements.historyPanel ||
        !Elements.historyPanel.classList
            .contains("is-open")
    ) {

        document.body.classList.remove(
            "tr-w007-modal-open"
        );

    }

}


/*==============================================================================
OPEN HISTORY
==============================================================================*/

function openHistory() {

    if (!Elements.historyPanel) {

        return;

    }


    renderHistory();


    closeReader();


    Elements.historyPanel.classList.add(
        "is-open"
    );

    Elements.historyPanel.setAttribute(
        "aria-hidden",
        "false"
    );


    document.body.classList.add(
        "tr-w007-modal-open"
    );


    if (Elements.historyClose) {

        window.setTimeout(

            () =>
                Elements.historyClose.focus(),

            30

        );

    }

}


/*==============================================================================
CLOSE HISTORY
==============================================================================*/

function closeHistory() {

    if (!Elements.historyPanel) {

        return;

    }


    Elements.historyPanel.classList.remove(
        "is-open"
    );

    Elements.historyPanel.setAttribute(
        "aria-hidden",
        "true"
    );


    if (
        !Elements.reader ||
        !Elements.reader.classList
            .contains("is-open")
    ) {

        document.body.classList.remove(
            "tr-w007-modal-open"
        );

    }

}


/*==============================================================================
RENDER HISTORY
==============================================================================*/

function renderHistory() {

    if (!Elements.historyList) {

        return;

    }


    if (
        !engineAvailable() ||
        typeof window.TrestleW007Engine
            .getRecentInsights !==
            "function"
    ) {

        Elements.historyList.innerHTML =
            `
                <p class="tr-w007-history-empty">
                    Recent Insights are not available right now.
                </p>
            `;

        return;

    }


    let history = [];


    try {

        history =
            window.TrestleW007Engine
                .getRecentInsights() || [];

    }

    catch (error) {

        console.error(
            "TRESTLE W007: Unable to load history.",
            error
        );

        history = [];

    }


    if (!history.length) {

        Elements.historyList.innerHTML =
            `
                <p class="tr-w007-history-empty">
                    No previous Insights are available yet.
                </p>
            `;

        return;

    }


    Elements.historyList.innerHTML =
        history

            .map(

                item => {

                    const date =
                        safeString(
                            item.date
                        );


                    const promise =
                        safeString(
                            item.promise
                        );


                    return `

                        <button
                            type="button"
                            class="tr-w007-history-item"
                            data-w007-history-date="${escapeHtml(date)}"
                        >

                            <span class="tr-w007-history-item-main">

                                <span class="tr-w007-history-date">
                                    ${escapeHtml(formatDate(date))}
                                </span>

                                <span class="tr-w007-history-promise">
                                    ${
                                        escapeHtml(
                                            promise ||
                                            "Your TRESTLE Insight"
                                        )
                                    }
                                </span>

                            </span>

                            <span
                                class="tr-w007-history-arrow"
                                aria-hidden="true"
                            >
                                ›
                            </span>

                        </button>

                    `;

                }

            )

            .join("");

}


/*==============================================================================
OPEN ARCHIVED INSIGHT
==============================================================================*/

function openArchivedInsight(
    date
) {

    if (
        !date ||
        !window.TrestleW007Engine ||
        typeof window.TrestleW007Engine
            .getSavedInsight !==
            "function"
    ) {

        return;

    }


    try {

        const insight =
            window.TrestleW007Engine
                .getSavedInsight(
                    date
                );


        if (!insight) {

            return;

        }


        openReader(
            insight
        );

    }

    catch (error) {

        console.error(
            "TRESTLE W007: Unable to open archived Insight.",
            error
        );

    }

}


/*==============================================================================
CHECK TODAY'S INSIGHT
==============================================================================*/

function checkTodayInsight() {

        if (!applyAccessState()) {
        return;
    }

    if (!engineAvailable()) {

        setStatus(
            "error",
            "Your Insight is temporarily unavailable."
        );

        setOpenButton(
            false,
            "View Today's Insight"
        );

        return;

    }


    let result = null;


    try {

        result =
            window.TrestleW007Engine
                .getTodayInsight();

    }

    catch (error) {

        console.error(
            "TRESTLE W007: Insight check failed.",
            error
        );


        setStatus(
            "error",
            "Your Insight is temporarily unavailable."
        );


        setOpenButton(
            false,
            "View Today's Insight"
        );


        return;

    }


    if (!result) {

        setStatus(
            "error",
            "Your Insight is temporarily unavailable."
        );

        setOpenButton(
            false,
            "View Today's Insight"
        );

        return;

    }


    switch (
        safeString(
            result.status
        )
    ) {


        case "READY":

            currentInsight =
                result.insight || null;


            setStatus(
                "ready",
                "Today's Insight is ready."
            );


            setOpenButton(
                Boolean(currentInsight),
                "View Today's Insight"
            );

            break;


        case "WAITING":

            currentInsight = null;


            setStatus(

                "waiting",

                safeString(
                    result.message
                ) ||
                "Your end-of-day Insight will be ready after 7 PM."

            );


            setOpenButton(
                false,
                "Available after 7 PM"
            );

            break;


        case "INSUFFICIENT_DATA":

            currentInsight =
                result.insight || null;


            setStatus(

                "light",

                safeString(
                    result.message
                ) ||
                "There isn't quite enough recorded today for a full Insight."

            );


            /*
            The restrained Insight can still be opened so
            TRESTLE does not punish a light-use day.
            */

            setOpenButton(
                Boolean(currentInsight),
                "View Today's Reflection"
            );

            break;


        default:

            currentInsight = null;


            setStatus(

                "error",

                safeString(
                    result.message
                ) ||
                "Today's Insight could not be prepared."

            );


            setOpenButton(
                false,
                "View Today's Insight"
            );

            break;

    }

}


/*==============================================================================
OPEN TODAY
==============================================================================*/

function openToday() {

    if (!currentInsight) {

        checkTodayInsight();

    }


    if (!currentInsight) {

        return;

    }


    openReader(
        currentInsight
    );

}


/*==============================================================================
BUILD SHARE TEXT
==============================================================================*/

function buildShareText(
    insight
) {

    if (!insight) {

        return "";

    }


    const lines = [];


    lines.push(
        "My TRESTLE Insight"
    );


    if (insight.date) {

        lines.push(
            formatDate(
                insight.date
            )
        );

    }


    if (
        insight.promiseInsight &&
        insight.promiseInsight.text
    ) {

        lines.push("");
        lines.push(
            safeString(
                insight.promiseInsight.text
            )
        );

    }


    if (
        insight.tomorrowFocus &&
        insight.tomorrowFocus.text
    ) {

        lines.push("");
        lines.push(
            "Tomorrow's small focus:"
        );

        lines.push(
            safeString(
                insight.tomorrowFocus.text
            )
        );

    }


    lines.push("");
    lines.push(
        "TRESTLE™ by Diafemme"
    );


    return lines.join("\n");

}


/*==============================================================================
SHARE
==============================================================================*/

async function shareInsight() {

    if (
        !currentInsight ||
        currentInsight.allowShare === false
    ) {

        return;

    }


    const text =
        buildShareText(
            currentInsight
        );


    if (!text) {

        return;

    }


    try {

        if (navigator.share) {

            await navigator.share({

                title:
                    "My TRESTLE Insight",

                text:
                    text

            });


            return;

        }


        if (
            navigator.clipboard &&
            typeof navigator.clipboard
                .writeText ===
                "function"
        ) {

            await navigator.clipboard
                .writeText(
                    text
                );


            const original =
                Elements.shareButton
                    ? Elements.shareButton
                        .textContent
                    : "";


            if (Elements.shareButton) {

                Elements.shareButton.textContent =
                    "Copied";

            }


            window.setTimeout(

                () => {

                    if (
                        Elements.shareButton
                    ) {

                        Elements.shareButton
                            .textContent =
                                original ||
                                "Share";

                    }

                },

                1600

            );


            return;

        }


        window.prompt(
            "Copy your TRESTLE Insight:",
            text
        );

    }

    catch (error) {

        /*
        AbortError normally means the user closed
        the native share panel. No warning needed.
        */

        if (
            error &&
            error.name ===
                "AbortError"
        ) {

            return;

        }


        console.error(
            "TRESTLE W007: Share failed.",
            error
        );

    }

}


/*==============================================================================
DOWNLOAD / PRINT
*
*No backend PDF service is used.
*
*The browser's print system creates the downloadable PDF.
*Our W007 print CSS isolates the Insight report.
==============================================================================*/

async function downloadInsight() {

    if (
        !currentInsight ||
        currentInsight.allowPdf === false
    ) {
        return;
    }

    if (
        !window.TrestleW007PDF ||
        typeof window.TrestleW007PDF.generate !== "function"
    ) {
        console.error(
            "TRESTLE W007: PDF Generator unavailable."
        );
        return;
    }

    const originalText =
        Elements.downloadButton
            ? Elements.downloadButton.textContent
            : "";

    try {

        if (Elements.downloadButton) {
            Elements.downloadButton.disabled = true;
            Elements.downloadButton.textContent =
                "Preparing PDF...";
        }

        await window.TrestleW007PDF.generate(
            currentInsight
        );

        if (Elements.downloadButton) {
            Elements.downloadButton.textContent =
                "Downloaded";
        }

    }

    catch (error) {

        console.error(
            "TRESTLE W007: PDF download failed.",
            error
        );

        if (Elements.downloadButton) {
            Elements.downloadButton.textContent =
                "Download failed";
        }

    }

    finally {

        window.setTimeout(
            () => {

                if (Elements.downloadButton) {
                    Elements.downloadButton.disabled =
                        false;

                    Elements.downloadButton.textContent =
                        originalText ||
                        "Download Insight";
                }

            },
            1600
        );

    }
}


/*==============================================================================
BIND EVENTS
==============================================================================*/

function bindEvents() {

    if (Elements.openButton) {

        Elements.openButton.addEventListener(

            "click",

            openToday

        );

    }


    if (Elements.historyButton) {

        Elements.historyButton.addEventListener(

            "click",

            openHistory

        );

    }


    if (Elements.closeButton) {

        Elements.closeButton.addEventListener(

            "click",

            closeReader

        );

    }


    if (Elements.historyClose) {

        Elements.historyClose.addEventListener(

            "click",

            closeHistory

        );

    }


    if (Elements.downloadButton) {

        Elements.downloadButton.addEventListener(

            "click",

            downloadInsight

        );

    }


    if (Elements.shareButton) {

        Elements.shareButton.addEventListener(

            "click",

            shareInsight

        );

    }


    root.addEventListener(

        "click",

        event => {


            if (
                event.target.closest(
                    "[data-w007-close]"
                )
            ) {

                closeReader();

                return;

            }


            if (
                event.target.closest(
                    "[data-w007-history-close]"
                )
            ) {

                closeHistory();

                return;

            }


            const historyItem =
                event.target.closest(
                    "[data-w007-history-date]"
                );


            if (historyItem) {

                openArchivedInsight(

                    historyItem.dataset
                        .w007HistoryDate

                );

            }

        }

    );


    document.addEventListener(

        "keydown",

        event => {

            if (
                event.key !==
                "Escape"
            ) {

                return;

            }


            if (
                Elements.reader &&
                Elements.reader.classList
                    .contains("is-open")
            ) {

                closeReader();

                return;

            }


            if (
                Elements.historyPanel &&
                Elements.historyPanel
                    .classList
                    .contains("is-open")
            ) {

                closeHistory();

            }

        }

    );

}


/*==============================================================================
REFRESH AFTER TRESTLE READY
*
*The workspace controller broadcasts trestle:ready
*after the Shopify-authenticated workspace/dashboard is loaded.
==============================================================================*/

function bindWorkspaceReady() {

    document.addEventListener(

        "trestle:ready",

        () => {

            window.setTimeout(

                checkTodayInsight,

                0

            );

        }

    );

}


/*==============================================================================
REFRESH AFTER W005 CHANGES
*
*W005 currently stores locally.
*
*This listener is intentionally generic. If W005 later broadcasts
*a check-in event, W007 can refresh without architectural changes.
==============================================================================*/

function bindLocalRefresh() {

    window.addEventListener(

        "focus",

        () => {

            if (
                !Elements.reader ||
                !Elements.reader.classList
                    .contains("is-open")
            ) {

                checkTodayInsight();

            }

        }

    );


    window.addEventListener(

        "storage",

        event => {

            if (!event) {

                return;

            }


            /*
            A localStorage change from another browser tab
            can affect today's W005 data or W007 archive.
            */

            checkTodayInsight();

        }

    );

}


/*==============================================================================
INITIALIZE
==============================================================================*/

function initialize() {

    if (!cacheElements()) {

        return;

    }


    if (
        root.dataset.w007Initialized ===
        "true"
    ) {

        return;

    }


    root.dataset.w007Initialized =
        "true";


    bindEvents();

    bindWorkspaceReady();

    bindLocalRefresh();


    /*
    Initial check is also required because the W007 Shopify
    section may initialize after trestle:ready was already fired.
    */

    window.setTimeout(

        checkTodayInsight,

        0

    );


    console.info(
        "TRESTLE W007 Insight UI Ready"
    );

}


/*==============================================================================
PUBLIC API
==============================================================================*/

return {

    initialize,


    refresh() {

        checkTodayInsight();

    },


    openToday() {

        openToday();

    },


    openHistory() {

        openHistory();

    },


    close() {

        closeReader();
        closeHistory();

    },


    getCurrentInsight() {

        return currentInsight;

    }

};

})();


/*==============================================================================
PUBLIC NAMESPACE
==============================================================================*/

window.TrestleW007 =
    TrestleW007;


/*==============================================================================
BOOT
==============================================================================*/

if (
    document.readyState ===
    "loading"
) {

    document.addEventListener(

        "DOMContentLoaded",

        () => {

            TrestleW007.initialize();

        }

    );

}

else {

    TrestleW007.initialize();

}


/*==============================================================================
TRESTLE™ W007
YOUR TRESTLE INSIGHT
UI CONTROLLER
Version 1.0
COMPLETE
==============================================================================*/